import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import slackService from '../services/slackService.js';
import { useFlexibleTranslation } from '../contexts/LanguageContext';
import { phSlackConnected } from '../utils/posthogEvents';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f4f4f4;
`;

const Message = styled.div`
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  margin-top: 1rem;
  padding: 1rem;
  background-color: #fff5f5;
  border-radius: 8px;
  max-width: 480px;
  text-align: center;
`;

const SlackCallback = () => {
  const navigate = useNavigate();
  const { t } = useFlexibleTranslation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = new URLSearchParams(window.location.search).get('code');
        if (!code) {
          throw new Error(t('slackCallback.noAuthorizationCode', 'No authorization code received from Slack'));
        }

        await slackService.authenticate(code);
        phSlackConnected();
        // Redirect to communications page after successful authentication
        navigate('/communications');
      } catch (error) {
        console.error('Error handling Slack callback:', error);
        // Show error message to user
        const errorElement = document.createElement('div');
        errorElement.className = 'error-message';
        errorElement.textContent = `${t('slackCallback.error', 'Error')}: ${error.message}`;
        document.body.appendChild(errorElement);
      }
    };

    handleCallback();
  }, [navigate, t]);

  return (
    <Container>
      <Message>{t('slackCallback.processingAuthentication', 'Processing Slack authentication...')}</Message>
    </Container>
  );
};

export default SlackCallback; 